import React from "react";
import { Col, Form, Row } from "react-bootstrap";

function SourceAddressAndAuthentication() {
  return (
    <div className="align-items-center rounded-3 mt-4 p-4 bg-purple-gradient-darker-reverse">
      <div className="ms-2">
        <span className="fs-4 fw-bold "> Source Address & Authentication</span>
      </div>
      <div className="text-secondary ms-2">
        Set up the source address and authentication to verify requests.
      </div>
      <div className="ms-3 my-3">
        <div>
          <Form.Group as={Row} className="mb-3" controlId="emailAddress">
            <Form.Label className="fw-bold">Email address :</Form.Label>
            <Col sm="10" className="p-2">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
        </div>
        <div>
          <Form.Group as={Row} className="mb-3" controlId="url">
            <Form.Label className="fw-bold">URL:</Form.Label>
            <Col sm="10">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
        </div>
        <div>
          <Form.Group as={Row} className="mb-3" controlId="url">
            <Form.Label className="fw-bold">Number:</Form.Label>
            <Col sm="10">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
        </div>
      </div>
    </div>
  );
}

export default SourceAddressAndAuthentication;
